// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__S8waU","dragIcon":"SortableItem_dragIcon__c5e9r","disabled":"SortableItem_disabled__3e9xR"};